import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PaginatedResultModel } from '@data-layer/models/common';
import {
  ManagementBondRequestManualStateModel,
  ManagementBondRequestModel,
  ManagementBondRequestShortModel,
  ManagementBondRequestsSearchModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class BondRequestsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: ManagementBondRequestsSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementBondRequestShortModel>> {
    return this.apiService.get(`${environment.url.bondRequestsManagement}`, { params }, { isShowLoader });
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementBondRequestModel> {
    return this.apiService.get(`${environment.url.bondRequestsManagement}${id}`, null, { isShowLoader });
  }

  public synchronize(id: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(`${environment.url.bondRequestsManagement}${id}/sync/data`, null, null, { isShowLoader });
  }

  public send(id: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(`${environment.url.bondRequestsManagement}sent?id=${id}`, null, null, { isShowLoader });
  }

  public updateState(id: number, state: ManagementBondRequestManualStateModel): Observable<void> {
    return this.apiService.put(`${environment.url.bondRequestsManagement}${id}/state`, state);
  }
}
